import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const ActiveDeactiveUser = (user_id,) => {
  
  return axios.delete(API + "company/customeruseractivate/"+user_id +'/',{headers: authHeader(),});
};
const ActivateDeActivatedCustomerUserService = {
    ActiveDeactiveUser,
  };
  export default ActivateDeActivatedCustomerUserService;